import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {SessionService} from './session.service';
import {noop} from '../utils/misc.util';
import {map, take} from "rxjs/operators";

@Injectable()
export class LoggedInGuard {
	constructor(private session: SessionService, private router: Router) {
	}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> | boolean {
		return this.session.islogged$.pipe(
			map((isLogged) => {
				if (isLogged) {
					return true;
				}
				this.router.navigate(['login']).then(noop);
				return false;
			}),
			take(1));
	}
}
